<script lang="ts">
    import {email, fetchOrigin, page, registration, serverConfig} from "./data";
    import AdminPage from "./pages/AdminPage.svelte";
    import EnterCodePage from "./pages/EnterCodePage.svelte";
    import EnterEmailPage from "./pages/EnterEmailPage.svelte";
    import RegistrationPage from "./pages/RegistrationPage.svelte";
    import {authorized_admins} from "@shared/Types.ts";
    import {onMount} from "svelte";

    onMount(async () => {
        const configResult = await fetchOrigin('/config');
        serverConfig.set(await configResult.json());
        console.log('serverConfig', $serverConfig)
    })
</script>

<header>
    <nav style="flex-wrap: wrap;">
        <ul>
            <img src="/favicon.png" style="height: 70px" alt="WOB Logo">
            <li><strong>WOB Registration Page</strong></li>
        </ul>
        {#if $page === 'Registration' || $page === 'Admin'}
            <li>{#if $registration?.firstName?.length > 0 && $registration?.lastName?.length > 0}
                {$registration.firstName} {$registration.lastName} - ({$email})
            {:else}
                {$email}
            {/if}
            {#if authorized_admins.includes($email)}
                - admin
            {/if}

            </li>
            {#if $page !== 'Admin' && authorized_admins.includes($email)}
                <li><button on:click={() => page.set('Admin')}>Admin Page</button></li>
            {:else if $page === 'Admin'}
                <li><button on:click={() => page.set('Registration')}>Registration Page</button></li>
            {/if}
            <li on:click={() => {$email = ''; page.set('EnterEmail')}}><a href="/logout">logout</a></li>
        {/if}
    </nav>
</header>

<main style={$page === 'EnterEmail' ? 'background-image: url("/misty-morning-lake.webp"); background-size: cover;' : ''}>
    <div class="container">
    {#if $page === 'Admin'}
        <AdminPage/>
    {:else if $page === 'EnterCode'}
        <EnterCodePage/>
    {:else if $page === 'EnterEmail'}
        <EnterEmailPage/>
    {:else if $page === 'Registration'}
        <RegistrationPage/>
    {/if}
    </div>
</main>

<footer style="padding-bottom: 2rem;">
    <small>© 2026 WOB Team & Forrest Milner.
        please contact woballsouls@gmail.com with any questions.
    </small>
</footer>

<style>
    header, footer {
        background-color: #cecece;
        padding-left: 2rem;
    }
    main {
        flex: 1;
    }
</style>